/**
 * Route for `kpi-instructions`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { KpiInstructionsPage } from "../features/kpi-instructions/KpiInstructionsPage";

export const kpiInstructionsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/kpi-instructions",
	component: KpiInstructionsPage,
});

export default kpiInstructionsRoute;
